/**
 * Wrapper class for clevertap integration
 */

import Auth from './AuthManager';
import API_ENDPOINTS from './apiConfig';
import config from './config';

const cleverTapLoader = () => config.get('cleverTap', {});

const handler = {
  get(target, propKey) {
      return (...args) => target()[propKey].call(null, args[0], args[1])
  }
};

const cleverTapProxy = new Proxy(cleverTapLoader, handler);

export default cleverTapProxy;
